<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import useExtraScript from '@composable/useExtraScript';
defineProps<{ showDrawer?: boolean }>();
const { isMrbilit } = useWhiteLabel();
useExtraScript();
const { y } = useWindowScroll();
</script>

<template>
    <div ref="el">
        <SiteHeader
            :show-drawer
            overlay-header
            desktop-color="white"
            menu-color="white"
            sticky-in-mobile
            class="header-container"
            :class="{ scrolled: y > 20 }"
        />
        <slot />
        <VitePwaManifest v-if="isMrbilit" />
    </div>
</template>
<style lang="scss" scoped>
.header-container {
    &.scrolled {
        @include mobile-only {
            :deep(.sticky) {
                -webkit-transition: background-color 1000ms linear;
                -ms-transition: background-color 1000ms linear;
                transition: background-color 100ms linear;
                background-color: usePalette($p-blue);
            }
        }
    }
    :deep() {
        @include mobile-only {
            .close-button-container {
                .mr-button {
                    &.filled {
                        background: none !important;
                    }
                }
            }
        }
        @include desktop-only {
            padding-bottom: 70px;
            background-color: white;
            .title,
            svg,
            p {
                color: usePalette($p-blue) !important;
            }
            .user-position:hover {
                .body {
                    .title,
                    svg {
                        color: white !important;
                    }
                }
                .edit-user-icon {
                    svg {
                        color: white !important;
                    }
                }
            }
        }
        a:hover {
            &.body {
                color: white !important;
            }
        }
    }
}
</style>
